import { ArrowCircleLeftOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import IndieButton from "./IndieButton";

const IndieBackButton = ({label, ...params}) => {
    const { t } = useTranslation();
    return <IndieButton startIcon={<ArrowCircleLeftOutlined/>} variant="outlined" color="primary" {...params}>{label ? label : t("label.button.back")}</IndieButton>
}

export default IndieBackButton;